/**
 * 뷰 세션 서비스
 * /api/viewer/books/{book_uuid}/view-sessions/start, stop API 연동
 */

import apiClient from '../../core/http/axios';

export interface ViewSessionStartResponse {
  success: boolean;
  error: string | null;
  data: {
    session_uuid: string;
    book_uuid: string;
    started_at: string;
  };
  code: string | null;
  meta?: { elapsed_ms: number };
}

export interface ViewSessionStopResponse {
  success: boolean;
  error: string | null;
  data: {
    closed: boolean;
    book_uuid: string;
    ended_at: string;
    end_type: string;
    reason?: string;
  };
  code: string | null;
  meta?: { elapsed_ms: number };
}

export type ViewSessionEndType = 'USER' | 'TIMEOUT' | 'SYSTEM';

export const viewSessionService = {
  /**
   * 뷰 세션 시작
   * @param bookUuid 책 UUID (book_uuid)
   */
  start: async (bookUuid: string): Promise<ViewSessionStartResponse['data']> => {
    const response = await apiClient.post<ViewSessionStartResponse>(
      `/viewer/books/${bookUuid}/view-sessions/start`,
      {},
      { headers: { accept: 'application/json' } }
    );
    if (!response.data.success) {
      throw new Error(response.data.error || '뷰 세션 시작에 실패했습니다.');
    }
    return response.data.data;
  },

  /**
   * 뷰 세션 종료
   * @param bookUuid 책 UUID (book_uuid)
   * @param endType 종료 유형 (USER: 사용자 이탈, TIMEOUT: 타임아웃, SYSTEM: 시스템)
   */
  stop: async (bookUuid: string, endType: ViewSessionEndType = 'USER'): Promise<ViewSessionStopResponse['data']> => {
    const response = await apiClient.post<ViewSessionStopResponse>(
      `/viewer/books/${bookUuid}/view-sessions/stop`,
      {},
      {
        params: { end_type: endType },
        headers: { accept: 'application/json' },
      }
    );
    if (!response.data.success) {
      throw new Error(response.data.error || '뷰 세션 종료에 실패했습니다.');
    }
    return response.data.data;
  },
};
